<template>
    <div class="automatic-reply">
        <div class="title" @click="openDrawer">平台助手</div>
        <el-dialog title="平台助手" :visible.sync="drawer" ref="drawer" top="0" :modal="false">
            <div class="automatic-reply-content">
                <div class="dialogBox" v-for="item in ChatHistory" :style="{justifyContent: item.isMe? 'flex-end' : 'flex-start'}">
                    <i v-if="!item.isMe" class="userIcon" :class="item.icon"></i>
                    <div class="dialog-content">
                        <div class="name" :style="{textAlign: item.isMe?'right':'left'}">{{ item.name }}</div>
                        <div class="context" :class="{blue1:item.isMe,blue2:!item.isMe}">{{ item.context }}</div>
                    </div>
                    <i v-if="item.isMe" class="userIcon" :class="item.icon"></i>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-input type="textarea" :rows="3" placeholder="请输入内容" @focus="listenerKeyup" v-model="textarea" @input="oninput" resize="none">
                </el-input>
                <i class="el-icon-top"></i>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'automaticReply',
    data() {
        return {
            drawer: false,
            textarea: '',
            keysPressed: {},
            ChatHistory:[
                {icon: 'el-icon-s-custom',name: '平台助手',context:'你好，我是平台助手，很高兴为您服务',isMe:false},
                {icon: 'el-icon-potato-strips',name: '用户A',context:'永远心疼giegie',isMe:true}
            ]
        }
    },
    methods: {
        openDrawer() {
            this.drawer = true;
        },
        listenerKeyup(){
            let that = this
            window.addEventListener('keydown', function(e){
                // console.log(e);
                that.keysPressed[e.key] = true;
                if(that.keysPressed.Enter && that.keysPressed.Shift){
                    that.textarea += '\n';
                }
                if(that.keysPressed.Enter && !that.keysPressed.Shift){
                    //console.log('enter',that.textarea);
                    that.ChatHistory.push({
                        icon: 'el-icon-potato-strips',
                        name: '用户A',
                        context:that.textarea,
                        isMe:true
                    })
                    that.textarea = '';
                }  
            });
            window.addEventListener('keyup', function(e){
                that.keysPressed[e.key] = false;
            });
            
        },
        oninput(e){
             this.textarea = e
        }
    }
}
</script>

<style scoped>
.title {
    cursor: pointer;
}

.title:hover {
    color: rgb(22, 132, 211);
}

.el-dialog__wrapper /deep/ .el-dialog {
    z-index: 999;
    margin: 0 0 50px auto !important;
    height: 100%;
    width: 35%;
}

.el-dialog__wrapper /deep/ .el-dialog .el-dialog__body {
    height: 75%;
}

.dialog-footer {
    display: flex;
    align-items: end;
    border-top: 1px solid #d4d4d4;
}
.el-dialog__footer .dialog-footer /deep/ .el-textarea textarea{
    border: none !important;
}
.dialogBox{
    display: flex;
    align-items: self-start;
    margin: 1.25rem 0;
}
.userIcon{
    font-size: 1.875rem;
}
.dialog-content .name{
   font-size: .625rem;
   text-align: left;
}
.dialog-content .context{
    /* border: 1px solid red; */
    padding: 10px;
    border-radius: 5px;
    text-align: left;
}
.blue1{
    background-color: rgb(169, 208, 255);
    color: #000;
}
.blue2{
    background-color: rgb(49, 142, 255);
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/automaticReply.vue